import React from "react";
import PropTypes from "prop-types";
import { intlShape } from "react-intl";
import FormField from "./FormField";
import { localise } from "./util";

const renderFlatRadioButtons = ({
  items,
  valueKey = "value",
  labelKey = "label",
  value,
  id,
  intl,
  error,
  meta,
  flat,
  ...rest
}) => (
  <div style={{ display: "flex", columnGap: "2rem" }}>
    {items.map((item, i) => (
      <label
        htmlFor={`${id}-${i}`}
        className="cxa-c-form__block-label cxa-c-form__block-label--radio"
        key={item[valueKey]}
      >
        <input
          type="radio"
          id={`${id}-${i}`}
          key={item[valueKey]}
          value={item[valueKey]}
          checked={item[valueKey] == value}
          {...rest}
        />{" "}
        {labelKey && localise(item[labelKey], intl)}
      </label>
    ))}
    {error && (
      <span
        style={{
          color: "#d9534f",
          fontSize: "0.75rem",
          lineHeight: "3.6rem",
          whiteSpace: "nowrap",
        }}
      >
        {error}
      </span>
    )}
  </div>
);

renderFlatRadioButtons.propTypes = {
  items: PropTypes.array,
  valueKey: PropTypes.string,
  labelKey: PropTypes.string,
  value: PropTypes.string,
  id: PropTypes.string,
  intl: intlShape.isRequired,
  error: PropTypes.any,
  meta: PropTypes.object,
  flat: PropTypes.any,
};

const RadioButtonsFlat = props => (
  <FormField component={renderFlatRadioButtons} {...props} hideError={true} />
);

export default RadioButtonsFlat;



// WEBPACK FOOTER //
// ./components/common/form-field/RadioButtonsFlat.js